import {flowTypes} from "@/common/service/page-config";
import { planTypes } from '@/common/constants';

export const tileStatusEnum = {
  BLANK: 0, // not touched
  NEED_VERIFY: 1, // not verified
  VERIFIED: 2, // verified
}

export const checkoutTileMap = {
  signUp: 'signUp',
  address: 'address',
  payment: 'payment',
  smsVerify: 'smsVerify',
  useVerification: 'useVerification',
}

export const THEME = {
  DARK: 'dark',
  LIGHT: 'light'
}

export const countriesWithState = ['US', 'CA', 'IN', 'AU', 'AE'];


export const COUNTRY_EXPLICIT_MARKETING_CONSENTS = {
  SOUTH_KOREA: 'KR'
}
/**
 * Need to show marketing right countries
 * EEA countries: Austria, Belgium, Bulgaria, Croatia, Republic of Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovakia, Slovenia, Spain, and Sweden.
 * Additional country: Israel.
 * */
export const COUNTRY_EUROPEAN_ECONOMIC_AREA = {
  "AUSTRIA": "AT",
  "BELGIUM": "BE",
  "BULGARIA": "BG",
  "CROATIA": "HR",
  "CZECH_REPUBLIC": "CZ",
  "CYPRUS": "CY",
  "DENMARK": "DK",
  "ESTONIA": "EE",
  "FINLAND": "FI",
  "FRANCE": "FR",
  "GERMANY": "DE",
  "GREECE": "GR",
  "HUNGARY": "HU",
  "IRELAND": "IE",
  "ISRAEL": "IL",
  "ITALY": "IT",
  "LATVIA": "LV",
  "LITHUANIA": "LT",
  "LUXEMBOURG": "LU",
  "MALTA": "MT",
  "NETHERLANDS": "NL",
  "POLAND": "PL",
  "PORTUGAL": "PT",
  "ROMANIA": "RO",
  "SLOVAKIA": "SK",
  "SLOVENIA": "SI",
  "SPAIN": "ES",
  "SWEDEN": "SE"
};

export const regionTypesEnum = {
  NOLIMITED_REGIONS: 0,
  COUNTRY_EXPLICIT_MARKETING_CONSENTS: 1, // KR only now
  COUNTRY_EUROPEAN_ECONOMIC_AREA: 2, // EEA countries and Israel
}

export const INR_DEFAULT_TAX_RATE = 0.18;

// this whitelist should be removed once India INR On-Session flow (3DS) is supported for all purchase flows
export const ON_SESSION_PAYMENT_SUPPORTED_FLOWS = [flowTypes.buyNow, flowTypes.basic2pro, flowTypes.edit, flowTypes.buyTrial, flowTypes.add2trial, flowTypes.trial2paid];
// Buy trial is not supported for UPI (field_authorizationAmount=0; doPayment='false')
export const UPI_PAYMENT_METHOD_UNSUPPORTED_FLOWS = [flowTypes.buyTrial, flowTypes.add2trial];
// VideoSDK is not supported for UPI (field_authorizationAmount=0; doPayment='false') Zuora error: ThreeDs2_Init_Exception - On-session payment is mandatory for Adyen-UPI.
export const UPI_PAYMENT_METHOD_UNSUPPORTED_PLAN_TYPES = [planTypes.VIDEO_SDK];
// ALTERNATIVE CREDIT CARD FOR ZUORA OUTAGE - supported flows for stripe cc when zuora outage
export const ZUORA_OUTAGE_ALTER_CC_SUPPORTED_FLOWS = [flowTypes.buyNow, flowTypes.basic2pro];
// UPI one-time payment for transactions greater than 15K
export const UPI_MAX_MANDATE_AMOUNT = 15000

// E-Wallets max purchase amounts
export const DEFAULT_KAKAO_PAY_MAX_AMOUNT = 2000000
export const DEFAULT_MOMO_PAY_MAX_AMOUNT = 50000000
export const DEFAULT_GCASH_MAX_AMOUNT = 100000

// Default value for eWallet second token check
export const DEFAULT_SECOND_TOKEN_MAX_POLLING_INTERVAL = 50; // 50 seconds
export const SECONDS_TO_ADD_TO_MAX_POLLING_INTERVAL = 30; // 30 seconds
